import { Box, CircularProgress, useMediaQuery } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { BottomTabBar } from 'components/bottom-tab-bar';
import { HeaderDesktop } from 'components/header-desktop';
import { useIsWebview } from 'hooks/general/use-is-webview';
import { QueryParam, useParseParamFromQuery } from 'hooks/general/use-parse-param-from-query';
import theme from 'providers/theme/theme';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';
import { articleSearchSchema } from 'router/schemas';
import { useStore } from 'store';

const Article = lazy(() => import('pages/article'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_public/_empty/article')({
  validateSearch: articleSearchSchema,
  component: ArticleWrapper,
});

function ArticleWrapper(): JSX.Element {
  const isWebview = useIsWebview();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const source = useParseParamFromQuery(QueryParam.SOURCE);
  const isInfoScreenOpen = useStore((state) => state.isInfoScreenOpen);

  const isOnboardingArticle = source === 'onboarding';
  const shouldHideNavigation = isInfoScreenOpen || isOnboardingArticle;

  const showHeader = !isWebview && isDesktop && !shouldHideNavigation;
  const showBottomBar = !isWebview && !isDesktop && !shouldHideNavigation;

  return (
    <Box pt={showHeader ? 30 : 0} pb={showBottomBar ? 25 : 0}>
      {showHeader && <HeaderDesktop />}
      <Suspense fallback={<Loader />}>
        <Article />
      </Suspense>
      {showBottomBar && <BottomTabBar />}
    </Box>
  );
}
